import * as React from 'react';
import Keys from './Keys';

const Keyboard = ({ releaseTime, octave, offset, setNote, stopNote, root, loadProgress, modulateNote, baseNotes }) => {
	return (
		<React.Fragment>
			<div style={{ height: '100%', width: '100%' }}>
				{baseNotes.map(bn => (
					<div key={bn} style={{ height: `${100 / baseNotes.length}%`, width: '100%', margin: 'auto' }}>
						<Keys
							loadProgress={loadProgress}
							releaseTime={releaseTime}
							octave={octave}
							offset={bn + offset}
							setNote={setNote}
							root={root}
							stopNote={stopNote}
							modulateNote={modulateNote}
						/>
					</div>
				))}
			</div>
		</React.Fragment>
	);
};

export default Keyboard;
